var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',{attrs:{"pills":"","id":"pagination400","align":"center","total-rows":_vm.totalRows,"per-page":_vm.meta.per_page},on:{"change":_vm.onChangePage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }